import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { SelectionType } from '@swimlane/ngx-datatable';
import { NgxSpinnerService } from 'ngx-spinner';
import { DashboardApiService } from 'src/app/core/services/api/dashboard-api.service';
import { FilesApiService } from 'src/app/core/services/api/files-api.service';
import { PrintService } from 'src/app/core/services/print.service';
import { FileSummaryModalComponent } from 'src/app/shared/file-summary-modal/file-summary-modal.component';
import { Case } from 'src/app/shared/models/cases/case';
import { CaseLite } from 'src/app/shared/models/cases/caseLite';
import { ClientSearchParams } from 'src/app/shared/models/clients/clientSearchParams';

@Component({
  selector: 'app-new-files-list',
  templateUrl: './new-files-list.component.html',
  styleUrls: ['./new-files-list.component.scss']
})
export class NewFilesListComponent implements OnInit {
  SelectionType = SelectionType;
  
  @Input() items: CaseLite[] = [];
  @Input() count = 0;
  @ViewChild('hearingsTable') hearingsTable: any;
  @ViewChild('fileSummaryModal') fileSummaryModal: FileSummaryModalComponent;
  
  @Output() updatedCount = new EventEmitter<number>();
  params: ClientSearchParams = new ClientSearchParams();
  constructor(private spinner: NgxSpinnerService,
    private filesApi: FilesApiService,
    private dashboardApi: DashboardApiService,
    private printService: PrintService) {
      if (!this.items.length) {
        this.loadItems();
      }
    }

  ngOnInit(): void {
  }


  loadItems() {
    this.spinner.show();
    this.dashboardApi.getNewCases(this.params).subscribe(
      r => {
        this.items = r.results;
        this.count = r.count;
        this.spinner.hide();
      }
    )
  }

  onPage(page) {
    this.params.page = page.offset + 1;
    this.loadItems();
  }

  onSelectFileSummary({ selected }) {
    this.spinner.show();
    this.filesApi.getFileSummary(selected[0].id).subscribe(
      r => {
        this.spinner.hide();
        this.fileSummaryModal.open(r);
      }
    );
  }
  
  updateCases(file: Case) {
    this.count = this.count > 0 ? --this.count : this.count;
    this.items = this.items.filter(f => f.id !== file.id);
    this.updatedCount.emit(this.count);
  }
}
